import React from 'react';
import xhr from '../xhr.js';
import { CSRF_TOKEN } from '../constants';
import Glyph from './glyph';

class FavoriteButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isActive: this.props.isActive
    };

    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    const { isActive } = this.state;
    const { id, type } = this.props;
    const urlSuffix = '.json';
    let method;
    let url = `/favorite_${type}`;

    if (isActive) {
      method = 'DELETE';
      url += `/${id}${urlSuffix}`;
    } else {
      method = 'POST';
      url += `${urlSuffix}?id=${id}`;
    }

    xhr(url, {
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': CSRF_TOKEN
      },
      method: method
    });

    this.setState({ isActive: !isActive });
    this.props.onFavoriteGroup(id, !isActive);
  }

  render() {
    const { isActive } = this.state;
    const glyphType = (isActive) ? 'solid' : 'stroke';
    const tooltip = (isActive) ? 'Remove from favorites' : 'Add to favorites';

    return (
      <button
        className={`favorite-button xsm mod-icon ${isActive ? 'is-on' : ''}`}
        data-pt-tooltip-hide-trigger="click"
        data-pt-tooltip-position="top-right"
        data-pt-tooltip={tooltip}
        onClick={this.onClick}
      >
        <Glyph name="star-2" type={glyphType} />
      </button>
    );
  }
}

export default FavoriteButton;
